// extracted by mini-css-extract-plugin
export default {"form":"Register_form__0RhmQ","actions":"Register_actions__yttfq","slideup":"Register_slideup__dAlKt","moveInFromLeft":"Register_moveInFromLeft__W-AO5","btn":"Register_btn__a1f-h"};